module.exports = __webpack_public_path__ + "img/driving_preview-600x450.6b93bf7c.jpg";